<template>
  <ModalDialog
    ref="dialog"
    title="Change Password"
    icon="fa-key"
    :submitting="submitting"
    submitTitle="Update"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="userForm" :labelColumnSize="2">
      <FormRow label="Current Password"><FormInputText type="password" v-model="user.currentPassword" field="currentPassword" /></FormRow>
      <FormHorizontalRule />
      <FormRow label="New Password"><FormInputText type="password" v-model="user.password" field="password" /></FormRow>
      <FormRow label="Confirm Password"><FormInputText type="password" v-model="user.confirmPassword" field="confirmPassword" /></FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: "UserChangePasswordDialog",
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    userId: Number
  },
  data() {
    return {
      user: { },
      userForm: {},
      submitting: false
    }
  },
  mounted() {

  },
  computed: {
  },
  methods: {
    show() {
      // Reset form
      this.user = { }
      this.userForm = {}
      this.submitting = false

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var userData = _.cloneDeep(this.$data.user)
      var updateData = _.pick(userData, ['currentPassword', 'password', 'confirmPassword'])

      this.$apiService.userService.updateCurrentUserPassword(updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.userForm = this.processFormResponse(err)
        })


    },
  }
}
</script>